import Vue from 'vue';
import axios from 'axios'
axios.interceptors.request.use(config => {
        setHttpBaseUrl(config);
        return config;
    }, err => {
        return Promise.reject(err)
    })
    // axios拦截响应
axios.interceptors.response.use(
    response => {
        return response;
    }, err => {
        return Promise.reject(err)
    })

function setHttpBaseUrl(config) {
    // 正式
    var api_zh_root = "https://official.juhaowu.cn/api";
    var api_en_root = "https://en.atoshi.info/api";
    // var api_intapi_zh = "https://shop.atoshi.org/intapi";
    var api_intapi_zh = "https://www.atoshi.info/intapi"
    var api_judgeIp = "https://shop.atoshi.org"
    // 测试
    // var api_zh_root = "http://181cnapp.juhaowu.cn/api";
    // var api_en_root = "https://en.atoshi.org/api";
    // var api_zh_intapi = "https://shop.atoshi.org/intapi"

    // 生产环境
    if (process.env.NODE_ENV == "production") {
        if(config.url.indexOf("judgeIp") == 0){
            config.url = config.url.replace(/judgeIp/g, api_judgeIp, "'$1'");
        }
        if (config.url.indexOf("api_zh") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "chinese";
            config.url = config.url.replace(/api_zh/g, api_zh_root, "'$1'");
        }
        if (config.url.indexOf("api_form_zh") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "chinese";
            config.url = config.url.replace(/api_form_zh/g, api_zh_root, "'$1'");
        }
        if (config.url.indexOf("api_intapi_zh") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.url = config.url.replace(/api_intapi_zh/g, api_intapi_zh, "'$1'");
        }
        if (config.url.indexOf("api_en") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "english";
            config.url = config.url.replace(/api_en/g, api_en_root, "'$1'");
        }
        if (config.url.indexOf("api_en_form") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "english";
            config.url = config.url.replace(/api_zh/g, api_zh_root, "'$1'");
        }
    }
    // 测试环境
    else
    {
        if(config.url.indexOf("judgeIp") == 0){
            config.url = config.url.replace(/judgeIp/g, api_judgeIp, "'$1'");
        }
        if (config.url.indexOf("api_zh") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "chinese";
            config.url = config.url.replace(/api_zh/g, api_zh_root, "'$1'");
        }
        if (config.url.indexOf("api_form_zh") == 0) {
            // console.log("api_zh_form")
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "chinese";
            config.url = config.url.replace(/api_form_zh/g, api_zh_root, "'$1'");
        }
        if (config.url.indexOf("api_intapi_zh") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            // config.url = config.url.replace(/api_zh_intapi/g, api_zh_intapi, "'$1'");
        }
        if (config.url.indexOf("api_en") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "english";
            config.url = config.url.replace(/api_en/g, api_en_root, "'$1'");
        }
        if (config.url.indexOf("api_en_form") == 0) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers['gtoken'] = "english";
            config.url = config.url.replace(/api_zh/g, api_zh_root, "'$1'");
        }
    }
}
export default {
    get(url, params) {
        //  addToken(params);
        return axios.get(url, params);
    },
    post(url, params) {
        //  addToken(params);
        return axios.post(url, params);
    }
}



// WEBPACK FOOTER //
// ./src/server/server.js